var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FCFDFF",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M120.4,22.9c0-9.3,7.5-16.8,16.8-16.8S154,13.6,154,22.9c0,9.3-7.5,16.8-16.8,16.8S120.4,32.2,120.4,22.9z  M46,170.6c0,0,39.8-17.4,40-17.5c1.4-0.7,1.7-1.4,1.9-2.9c0-0.1,5.1-27.1,5.1-27.1l20.9,25.3l-6.4,43.1 c-0.4,14.4,17.9,13.7,19.7,0.1l6.3-42c0.3-4.8-1.3-8.8-2.8-11.4l-22.1-30L120,84.3l-0.2,12.9c0,4.3,3.5,7.9,7.8,7.9 c0,0,31.5,0,31.8,0c0.7,0,1.4-0.3,2.1-0.6c3.1-1.2,5.3-4.2,5.3-7.7c0-4.6-3.7-8.2-8.2-8.2c0,0-23.5-0.4-23.5-0.4V55.6 c0-2.8-0.8-6.7-3.4-9.8c-2.2-3.6-7.1-7.1-11.3-7.6c-7.3-0.9-13.6,2.6-17.4,8.3c0,0-22.5,41.1-23.4,43.5c-0.4,0.7-9.5,49-9.5,49 l-33.6,13.7C26.4,157.1,30.2,175.3,46,170.6z M246.2,218.1c-2.7,3.3-6.4,5.3-10.5,5.7l-2.6,0.3V256h-35v-28.6L53,241.2V256H19v-11.5 c-1,0-0.5,0-0.6,0c-3.6,0-7.3-1.3-10.2-3.6c-3.3-2.7-5.3-6.5-5.7-10.6c-0.4-4.2,0.9-8.3,3.5-11.5c2.7-3.3,6.5-5.3,10.6-5.7 l194.8-18.6l-34.9-84.8L170,116l-6.5-6.7l51.3-49.6l6.5,6.7l-32.9,31.8l39,94.7l5-0.5c4.2-0.4,8.3,0.9,11.5,3.5 c3.3,2.7,5.3,6.5,5.7,10.6C250,210.8,248.9,214.9,246.2,218.1z M240.7,207.5c-0.2-1.8-1-3.4-2.4-4.6c-1.2-1-2.7-1.6-4.3-1.6 c-0.2,0-0.4,0-0.6,0L17.6,222c-1.8,0.2-3.4,1-4.6,2.4c-1.2,1.4-1.7,3.1-1.5,4.9c0.2,1.8,1,3.4,2.4,4.6s3.1,1.7,4.9,1.5l215.8-20.6 c1.8-0.2,3.4-1,4.6-2.4S240.8,209.3,240.7,207.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.d42ae87ad62612f1510b1078c912755e.svg";
export { ForwardRef as ReactComponent };